export const questionType = {
  learningEffectiveness: "LEARNING_EFFECTIVENESS",
  teachingEffectiveness: "TEACHING_EFFECTIVENESS",
  facilitatorsAttributes: "FACILITATORS_ATTRIBUTES",
  changeLeadersAttributes: "CHANGE_LEADERS_ATTRIBUTES",
  learningProcessCompliance: "LEARNING_PROCESS_COMPLIANCE",
  remarks: "REMARKS",
  actionItems: "ACTION_ITEMS",
  otherActions: "OTHER_ACTIONS",
};

export const statusType = {
  Pending: "Pending",
  Scheduled: "Scheduled",
  Rescheduled: "Rescheduled",
  Observed: "CO captured",
  Completed: "Completed",
};

export const scheduleTypes = {
  Mentoring: "Mentoring",
  Observation: "Classroom Observation",
};

export const allSupportActivities = [
  "Virtual handshake",
  "Content adoption or LX migration support",
  "Feedback session",
  "Knowledge session",
  "Orientation to TTT participants",
  "OJT session to TTT participants",
  "CO feedback documentation or upload on FSS app",
  "CO feedback discussion with facilitator",
  "FSC feedback Interaction with TD team",
  "CO Observation",
];

export const attendeeNameRequiredActivities = [
  "Virtual handshake",
  "Content adoption or LX migration support",
  "Feedback session",
  "Knowledge session",
  "CO feedback documentation or upload on FSS app",
  "CO feedback discussion with facilitator",
  "FSC feedback Interaction with TD team",
  "CO Observation",
];

export const attendeeNameNotRequiredActivities = [
  "Orientation to TTT participants",
  "OJT session to TTT participants",
];

export const specialChars = /[!@#$%^&*_+\-=\[\]{};:\\|<>\/?]+/;
export const allowedChars = /,"."()/;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const radioGroupMenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export function getStyles(name, list, theme) {
  return {
    fontWeight:
      list.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export const PROGRAM_NAME = {
  6: "Odisha Program",
  13: "FSS Program",
  9:"Entrepreneurship",
};
export const ROLE_IDS = {
  FSC_ROLE: 65,
};

export const PROGRAM_MAP = {
  6: "Odisha ITI",
  9: "Entrepreneurship",
  13: "Facilitator Support System",
};

export const FSS_CONFIG = {
  DEFAULT_PROGRAM_ID: 13,
};